export default "__VITE_PUBLIC_ASSET__0b9468bb__"